import React, { useState } from "react";
import styles from "./Toolbar.module.css";
import Logo from "../../../utilities/logo/Logo";
import NavigationItems from "../items/NavigationItems";
import SideDrawer from "../sidedrawer/SideDrawer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Toolbar = (props) => {
	const [showSideBar, setShowSideBar] = useState(false);

	const sideBarToggleHandler = () => {
		setShowSideBar(!showSideBar);
	};
	return (
		<>
			<header className={styles.Toolbar}>
				<div className={styles.logo}>
					<Logo source="zameen" />
				</div>
				<nav className={styles.DesktopOnly}>
					<NavigationItems />
				</nav>
				<button
					onClick={sideBarToggleHandler}
					className={[styles.sideBarBtn, styles.MobileOnly].join(" ")}
				>
					<FontAwesomeIcon icon={"bars"} />
				</button>
			</header>
			{showSideBar ? <SideDrawer toggleHandler={sideBarToggleHandler} /> : null}
		</>
	);
};

export default Toolbar;
